export const adminKeys = {
  all: ['admin'] as const,
  files: () => [...adminKeys.all, 'files'] as const,
  usersActivity: () => [...adminKeys.all, 'users-activity'] as const,
}
